<template>
    <v-main class="lyt-container pt-3 justify-center custom-main">
        <v-container>
            <v-row class="d-flex justify-center white--text">
                <h1><i class="fas fa-mobile"></i> Dispositivos en elección</h1>
            </v-row>
            <v-row class="d-flex justify-center mt-4 table-admins">
                <v-data-table
                    :headers="headers"
                    :items="devices"
                    :search="search"
                    class="datatable-admins"
                >
                    <template v-slot:top>
                        <v-select
                            v-model="electionIdSelected"
                            :item-text="textItemElection"
                            :items="elecciones"
                            :loading="isLoading"
                            class="mx-4"
                            item-value="id"
                            label="Selecciona elección"
                            @change="onChangeElection"
                        >
                        </v-select>
                        <v-text-field
                            v-model="search"
                            class="mx-4"
                            label="Buscar"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    :disabled="isLoading || !electionIdSelected"
                                    :loading="isLoading"
                                    @click="onChangeElection"
                                >
                                    <i class="fa fa-sync"></i>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn
                            :disabled="deletingDevice"
                            class="red white--text"
                            small
                            @click="askForDeleteConfirmation(item)"
                        >
                            <span v-if="!deletingDevice">
                                <i class="fa fa-trash"></i>
                            </span>
                            <span v-else>
                                <i class="fa fa-spinner fa-spin"></i>
                            </span>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-row>
        </v-container>
        <v-dialog v-model="showDeleteConfirmation" max-width="330">
            <v-card>
                <v-card-title class="headline">
                    Borrar dispositivo
                </v-card-title>
                <v-card-text>
                    Si continuas el dispositivo '{{
                        deviceToDelete.device_name
                    }}' del código {{ deviceToDelete.user_id }} de tipo '{{
                        deviceToDelete.type_user
                    }}' se eliminará, pero seguirá teniendo acceso, si la
                    elección se encuentra activa.
                    <br />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="!deletingDevice"
                        text
                        @click="showDeleteConfirmation = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="deletingDevice"
                        color="red darken-1"
                        text
                        @click="deleteDevice"
                    >
                        <template v-if="!deletingDevice">
                            Sí, eliminar
                        </template>
                        <span v-else>
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-main>
</template>
<script>
import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';

export default {
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    components: {},
    data() {
        return {
            headers: [
                {
                    text: 'Código',
                    value: 'user_id',
                },
                {
                    text: 'Modelo',
                    value: 'device_name',
                },
                {
                    text: 'uuid',
                    value: 'uuid',
                },
                {
                    text: 'SO',
                    value: 'device_os',
                },
                {
                    text: 'Habilitado',
                    value: 'multiple_enable',
                },
                {
                    text: 'Registro',
                    value: 'created_at',
                },
                {
                    text: 'Acciones',
                    value: 'actions',
                    sortable: false,
                },
            ],
            devices: [],
            deletingDevice: false,
            deviceToDelete: {},
            search: '',
            electionIdSelected: '',
            isLoading: true,
            showDeleteConfirmation: false,
        };
    },
    methods: {
        onChangeElection() {
            this.loadDevices();
        },
        loadDevices() {
            this.devices = [];
            if (this.electionIdSelected == '') {
                return;
            }
            this.isLoading = true;
            this.$store
                .dispatch('funcionarios/getDevices', this.electionIdSelected)
                .then(res => {
                    if (res.data) {
                        this.devices = res.data.map(device => {
                            device.multiple_enable = device.multiple_enable
                                ? 'Sí'
                                : 'No';
                            device.created_at = DateTime.fromISO(
                                device.created_at
                            ).toLocaleString(DateTime.DATETIME_MED);
                            return device;
                        });
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        deleteDevice() {
            if (!this.deviceToDelete) {
                return;
            }
            this.deletingDevice = true;
            this.$store
                .dispatch('funcionarios/deleteDevice', this.deviceToDelete.id)
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.deviceToDelete = {};
                    this.deletingDevice = false;
                    this.showDeleteConfirmation = false;
                    this.loadDevices();
                });
        },
        askForDeleteConfirmation(item) {
            this.deviceToDelete = item;
            this.showDeleteConfirmation = true;
        },
        textItemElection: item =>
            `${item.id} | ${item.description} | ${item.type.toUpperCase()}`,
    },
    created() {
        this.$store.dispatch('elecciones/getElecciones');
        this.isLoading = false;
    },
};
</script>
<style lang="scss">
.lyt-container {
    background-image: url('../assets/bg_udg.png');
    background-color: $votex-background-primary;
}

.table-admins {
    margin-bottom: 100px;

    .datatable-admins {
        width: 100%;
    }
}
</style>
